function formatToIndianCurrency(amount) {
  var newAmount = amount;
  var x = newAmount.toString();
  var lastThree = x.substring(x.length - 3);
  var otherNumbers = x.substring(0, x.length - 3);
  if (otherNumbers != "") lastThree = "," + lastThree;
  var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  return res;
}

/*function saveToLocalStorage(key, value) {
  // Get the current time in milliseconds
  const now = new Date().getTime();

  // Define the expiration time in milliseconds (30 days)
  const expirationTime = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

  // Create an object to store both the value and the expiration time
  const item = {
    value: value,
    expiry: now + expirationTime,
  };

  // Save the object as a JSON string in local storage
  localStorage.setItem(key, JSON.stringify(item));
}*/

function getCookie(name) {
    // Get all cookies as a string
    let cookies = document.cookie;
    
    // Create a regular expression to find the cookie with the specified name
    let match = cookies.match(new RegExp('(^| )' + name + '=([^;]+)'));
    
    // If a match is found, return the value; otherwise, return null
    if (match) {
        return decodeURIComponent(match[2]);
    } else {
        return null;
    }
}

function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        // Calculate the expiration date
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    // Set the cookie
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
  console.log('name', name, getCookie(name));
}


 function updateStickyCart() {
    $.ajax({
      type: "POST",
      url: "/cart.js",
      dataType: "json",
      success: function (cart) {
        var convertedCartPrice = (cart.total_price / 100).toFixed(0); //.toFixed(2);
        //console.log(cart);
        var priceFormatInINR = formatToIndianCurrency(convertedCartPrice);
        console.log(priceFormatInINR);
        if (cart.item_count > 1) {
          $(".item-count-layout").text(`${cart.item_count} Items`);
        } else {
          $(".item-count-layout").text(`${cart.item_count} Item`);
        }
        $(".item-total-layout").text(`₹${priceFormatInINR}`);
        
        if (cart.items.length > 0) {
          $(".CartBottom-SectionMain").addClass("active");
        } else {
          $(".CartBottom-SectionMain").removeClass("active");
        }
        if (cart.item_count > 1) {
          $(".cart-link__bubble-num").text(cart.item_count);
        } else {
          $(".cart-link__bubble").addClass("cart-link__bubble--visible");
          $(".cart-link__bubble-num").text(cart.item_count);
        }
      },
    });
  }



$(document).ready(function () {
 
  var addToCartClicked = function (id, shownNotification) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: id,
      },
      dataType: "json",
      success: function (data) {
        //window.SLIDECART_UPDATE(1000);
        //console.log("data", data);
        if (shownNotification) {
          $(".CartNotifaction-Sec").addClass("active");
          $(".textnot").text(" Product Successfully Added To Cart");
        }
       let storedDiscount = getCookie("discount_code");
        var discountApplied = false;
    
        if (storedDiscount) {
            discountApplied = true;
        } 
        
        $.ajax({
            type: "POST",
            url: "/cart.js",
            dataType: "json",
            success: function (cart) {
              window.postMessage({
                type: "innovist_cart_callback",
                data: cart,
              });
              if (!discountApplied) {
                updateStickyCart();
          }
        }
        });
        /*$.ajax({
            type: "POST",
            url: "/cart.js",
            dataType: "json",
            success: function (cart) {
              window.postMessage({
                type: "innovist_cart_callback",
                data: cart,
              });
              //console.log(cart);
              //var convertedCartPrice = (cart.total_price / 100).toFixed(0); //.toFixed(2);
              //var priceFormatInINR = formatToIndianCurrency(convertedCartPrice);

              //if (cart.item_count > 1) {
              //  $(".item-count-layout").text(`${cart.item_count} Items`);
              //} else {
              //  $(".item-count-layout").text(`${cart.item_count} Item`);
              //}
              //$('.item-total-layout').text(`₹${cart.total_price}`).slice(0,-1);
              //$(".item-total-layout").text(`₹${priceFormatInINR}`);

              //if (cart.items.length > 0) {
              //  $(".CartBottom-SectionMain").addClass("active");
              //} else {
              //  $(".CartBottom-SectionMain").removeClass("active");
              // }

              if (cart.item_count > 1) {
                $(".cart-link__bubble-num").text(cart.item_count);
              } else {
                $(".cart-link__bubble").addClass("cart-link__bubble--visible");
                $(".cart-link__bubble-num").text(cart.item_count);
              }
            },
          });
        }*/
      },
    });
  };

// Add to Cart Function
$(".Addtocart_buttonsec button").click(function () {
  // Ensure the dataLayer is initialized
  window.dataLayer = window.dataLayer || [];


  var buttonId = $(this).data("id");
  var productHandle = $(this).data("handle");
  var productIndex = $(this).data("index");
  var productClickFrom = $(this).data("click");

  if (!productIndex) {
    var parentElement = $(this).closest(".grid-item.grid-product");
    productIndex = $(parentElement).attr("data-slick-index") || "unknown"; // Fallback value
  }

  addToCartClicked(buttonId, true);

  // Fetch product data
  jQuery.getJSON(`/products/${productHandle}.js`)
    .done(function (productData) {
      if (!productData || !productData.id) {
        console.error("Invalid product data received:", productData);
        return;
      }
       // Get the referrer link and page type
  var prevlink = location.href;
 
  var prevpageType = '';

if (prevlink === 'https://innovist.com/' || prevlink === 'https://innovist.com') 
 {
    prevpageType = "Home Page";
  } else if (prevlink.includes("products")) {
    prevpageType = "Product Page";
 }
else if (prevlink.includes("collection")) {
    prevpageType = "Collection Page";
  } 
   else if (prevlink.includes("page")) {
    prevpageType = "Static Page";
  } else {
    prevpageType = "NA";
  }


      var eventData = {
        event: "Custom_addtocart",
        ecommerce: {
          // timestamp: new Date().toISOString(),
          page_location: window.location.href,
          page_title: document.title,
          click_from: productData.handle,
          rank: productIndex,
          ecomm_pagetype: prevpageType,
          value: productData.price / 100, // Convert to numeric value
          currency: "INR",
          items: [
            {
              item_id: `shopify_IN_${productData.id}_${buttonId}`,
              item_name: productData.title,
              item_brand: productData.vendor,
              item_category: productData.type || "null", // Fallback if no category
              price: productData.price / 100, // Numeric value
              quantity: 1,
              item_variant:
                productData.variants.find((v) => v.id == buttonId)?.title || "null",
            },
          ],
        },
      };

      // Clear previous ecommerce object and push new event
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(eventData);
    })
    .fail(function (jqxhr, textStatus, error) {
      console.error("Error fetching product data:", textStatus, error);
    });

  // Show loader
  $(this).parents(".Addtocart_buttonsec").find(".loadersec").addClass("active");

  setTimeout(function () {
    $(".Addtocart_buttonsec .loadersec").removeClass("active");
  }, 2000);

  setTimeout(function () {
    $(".CartNotifaction-Sec").removeClass("active");
  }, 3000);
});


  // Plus Function
  $(".qty-plus-minus-card-prod .plus").click(function () {
    var qunatityval = Number(
      $(this).parents(".qty-plus-minus-card-prod").find("#qty").val()
    );
    var valuesec = qunatityval + 1;
    $(this).parents(".qty-plus-minus-card-prod").find("#qty").val(valuesec);
    var variantId = $(this).data("id");
    addToCartClicked(variantId, false);
  });

  // Minus Function
  $(".qty-plus-minus-card-prod .min").click(function () {
    var qunatityval = Number(
      $(this).parents(".qty-plus-minus-card-prod").find("#qty").val()
    );
    var valuesec = qunatityval - 1;
    if (valuesec > 0) {
      $(this).parents(".qty-plus-minus-card-prod").find("#qty").val(valuesec);
    } else {
      $(this)
        .parents(".Addtocart_buttonsec")
        .find(".qty-plus-minus-card-prod")
        .removeClass("active");
      $(this).parents(".Addtocart_buttonsec").find("button").show();
      $(".CartNotifaction-Sec").addClass("active");
      $(".textnot").text("Product has been removed from cart");
    }

    var variantId = $(this).data("id");
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        quantity: valuesec,
        id: variantId,
      },
      success: (data) => {
        //window.SLIDECART_UPDATE(1000);
        //$(".CartNotifaction-Sec").addClass("active");
        $.ajax({
          type: "POST",
          url: "/cart.js",
          dataType: "json",
          success: function (cart) {
            //window.postMessage({type: 'innovist_cart_callback', data: cart})
            var convertedCartPrice = (cart.total_price / 100).toFixed(0); //.toFixed(2);

            var priceFormatInINR = formatToIndianCurrency(convertedCartPrice);
            if (cart.item_count > 1) {
              $(".item-count-layout").text(`${cart.item_count} Items`);
            } else {
              $(".item-count-layout").text(`${cart.item_count} Item`);
            }
            console.log(priceFormatInINR);
            $(".item-total-layout").text(`₹${priceFormatInINR}`);
            if (cart.items.length > 0) {
              $(".CartBottom-SectionMain").addClass("active");
            } else {
              $(".CartBottom-SectionMain").removeClass("active");
            }
            $(".cart-link__bubble-num").text(cart.item_count);
          },
        });
      },
      error: (err) => {
        console.error("err", err);
      },
    });

    setTimeout(function () {
      $(".CartNotifaction-Sec").removeClass("active");
    }, 3000);
  });

  //Cart Drawer Open Function

  $("#HeaderCartTrigger").click(function () {
    window.openGokwikSideCart();
    jQuery.getJSON(`/cart.js`, function (cartDetails) {
      var productData = [];

      for (var productDataIndex in cartDetails.items) {
        var product = cartDetails.items[productDataIndex];
        var item = {};
        item.price = product.price / 100;
        item.compare_at_price =
          product.compare_at_price !== undefined
            ? product.compare_at_price / 100
            : product.price / 100;
        item.vendor = product.vendor;
        item.variant_id = product.id;
        item.product_id = product.product_id;
        item.url = product.url;
        item.handle = product.handle;
        item.title = product.title;
        item.quantity = product.quantity;
        productData.push(item);
      }

      var cartData = {
        original_total_price: cartDetails.original_total_price / 100,
        items_subtotal_price: cartDetails.items_subtotal_price / 100,
        item_count: cartDetails.item_count,
        product_data: productData,
        click_from: "header",
      };
      window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
  event: "view_cart",
    ...cartData,               // Spread the entire userData object     
      });
    });
  });



  $(".CartNotifaction-Sec span a, .CartBottom-SectionMain").click(function () {
    $(".CartBottom-SectionMain .buy-now-button").addClass("view-cart-btn");
    window.openGokwikSideCart();
    setTimeout(function () {
      $(".CartBottom-SectionMain .buy-now-button").removeClass("view-cart-btn");
    }, 1000);
    jQuery.getJSON(`/cart.js`, function (cartDetails) {
      var productData = [];

      for (var productDataIndex in cartDetails.items) {
        var product = cartDetails.items[productDataIndex];
        var item = {};
        item.price = product.price / 100;
        item.compare_at_price =
          product.compare_at_price !== undefined
            ? product.compare_at_price / 100
            : product.price / 100;
        item.vendor = product.vendor;
        item.variant_id = product.id;
        item.product_id = product.product_id;
        item.url = product.url;
        item.handle = product.handle;
        item.title = product.title;
        item.quantity = product.quantity;
        productData.push(item);
      }

      var cartData = {
        original_total_price: cartDetails.original_total_price / 100,
        items_subtotal_price: cartDetails.items_subtotal_price / 100,
        item_count: cartDetails.item_count,
        product_data: productData,
        click_from: "cta_sticky",
      };
         window.dataLayer = window.dataLayer || [];
         window.dataLayer.push({
  event: "view_cart",
    ...cartData, 
      //console.log('cartData', cartData);
      // gtag("event", "view_cart", cartData);
      });   
    });
  });

  
});



// Add to Cart Function
$(".mainbutton_addtocart button").click(async function () {
  window.dataLayer = window.dataLayer || [];

  const $button = $(this);
  const buttonId = $button.data("id");
  const productHandle = $button.data("handle");


// Fetch product data
  jQuery.getJSON(`/products/${productHandle}.js`)
    .done(function (productData) {
      if (!productData || !productData.id) {
        console.error("Invalid product data received:", productData);
        return;
      }
       // Get the referrer link and page type
  var prevlink = location.href;
 
  var prevpageType = '';

if (prevlink === 'https://innovist.com/' || prevlink === 'https://innovist.com') 
 {
    prevpageType = "Home Page";
  } else if (prevlink.includes("products")) {
    prevpageType = "Product Page";
 }
else if (prevlink.includes("collection")) {
    prevpageType = "Collection Page";
  } 
   else if (prevlink.includes("page")) {
    prevpageType = "Static Page";
  } else {
    prevpageType = "NA";
  }
   var eventData = {
        event: "Custom_addtocart",
        ecommerce: {
          // timestamp: new Date().toISOString(),
          page_location: window.location.href,
          page_title: document.title,
          click_from: productData.handle,
          rank: "null",
          ecomm_pagetype: prevpageType,
          value: productData.price / 100, // Convert to numeric value
          currency: "INR",
          items: [
            {
              item_id: `shopify_IN_${productData.id}_${buttonId}`,
              item_name: productData.title,
              item_brand: productData.vendor,
              item_category: productData.type || "null", // Fallback if no category
              price: productData.price / 100, // Numeric value
              quantity: 1,
              item_variant:
                productData.variants.find((v) => v.id == buttonId)?.title || "null",
            },
          ],
        },
      };

      // Clear previous ecommerce object and push new event
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(eventData);
    })
    .fail(function (jqxhr, textStatus, error) {
      console.error("Error fetching product data:", textStatus, error);
    });
 
  setTimeout(function () {
    setTimeout(function () { 
      $(".CartNotifaction-Sec").removeClass("active");
    }, 3000);
    $(".CartNotifaction-Sec").addClass("active");
    // var loaderhtml = $(
    //   `<div class="loadersec"><img src="https://cdn.shopify.com/s/files/1/0039/6073/3763/files/Innovist_loader_1.gif?v=1720105774" width="40" height="40"></div>`
    // );
    // var btnText = $(`<span>Add to cart</span>`);
    // $(".add-to-cart").html(loaderhtml);
  
    // setTimeout(function () {
    //   $(".add-to-cart").html(btnText);
    // }, 1000);
    
  },1000);

});

